import styled from "styled-components";

export const Container = styled.div`
  .selected {
    background-color: rgba(0,120,255,.3);
  }
  tr.selectable-row {
    cursor: pointer;
  }
`